document.addEventListener('DOMContentLoaded', function () {
    // Vertical tabs functionality
    const tabButtons = document.querySelectorAll('.tab-button');
    const tabPanels = document.querySelectorAll('.tab-panel');

    tabButtons.forEach(button => {
        button.addEventListener('click', function () {
            const targetTab = this.getAttribute('data-tab');

            // Remove active class from all buttons and panels
            tabButtons.forEach(btn => btn.classList.remove('active'));
            tabPanels.forEach(panel => panel.classList.remove('active'));

            // Add active class to clicked button and corresponding panel
            this.classList.add('active');
            const targetPanel = document.getElementById(targetTab);
            if (targetPanel) {
                targetPanel.classList.add('active');
            }
        });
    });

    // Quantity controls functionality - sync custom controls with Shopify
    const quantityInput = document.querySelector('#quantity');
    const shopifyQuantityInput = document.querySelector('.quantity__input');
    const minusBtn = document.querySelector('.quantity-btn.minus');
    const plusBtn = document.querySelector('.quantity-btn.plus');

    // Sync custom quantity controls with Shopify quantity input
    if (minusBtn && (quantityInput || shopifyQuantityInput)) {
        minusBtn.addEventListener('click', function () {
            const input = shopifyQuantityInput || quantityInput;
            const currentValue = parseInt(input.value);
            const minValue = parseInt(input.getAttribute('min')) || 1;
            if (currentValue > minValue) {
                input.value = currentValue - 1;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                // Sync with custom input if both exist
                if (quantityInput && shopifyQuantityInput && input === shopifyQuantityInput) {
                    quantityInput.value = input.value;
                } else if (quantityInput && shopifyQuantityInput && input === quantityInput) {
                    shopifyQuantityInput.value = input.value;
                }
            }
        });
    }

    if (plusBtn && (quantityInput || shopifyQuantityInput)) {
        plusBtn.addEventListener('click', function () {
            const input = shopifyQuantityInput || quantityInput;
            const currentValue = parseInt(input.value);
            const maxValue = parseInt(input.getAttribute('max'));
            if (!maxValue || currentValue < maxValue) {
                input.value = currentValue + 1;
                input.dispatchEvent(new Event('change', { bubbles: true }));
                // Sync with custom input if both exist
                if (quantityInput && shopifyQuantityInput && input === shopifyQuantityInput) {
                    quantityInput.value = input.value;
                } else if (quantityInput && shopifyQuantityInput && input === quantityInput) {
                    shopifyQuantityInput.value = input.value;
                }
            }
        });
    }

    // Sync between custom quantity input and Shopify quantity input
    if (quantityInput && shopifyQuantityInput) {
        quantityInput.addEventListener('input', function () {
            shopifyQuantityInput.value = this.value;
            shopifyQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });

        shopifyQuantityInput.addEventListener('input', function () {
            quantityInput.value = this.value;
        });
    }

    // The actual add to cart functionality is now handled by Shopify's product-form.js
    // which is included in the buy-buttons snippet
});
